import { Installation } from 'common-billing-server/types'

type InstallationLastReportedFields = Pick<Installation, 'lastReportedPeriodStartAt' | 'lastReportedPeriod2StartAt'>

export function getLastReportedPeriodStart(installation: InstallationLastReportedFields): Date | null {
    const { lastReportedPeriodStartAt: v1, lastReportedPeriod2StartAt: v2 } = installation
    if (v1 && v2) {
        return v1.getTime() >= v2.getTime() ? v1 : v2
    }
    return v1 ?? v2 ?? null
}
